import actions from "./actions.js";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state() {
    return {
      userId: null,
      token:null,
      userType:null,
      didAutoLogout: false
    };
  },
  mutations,
  actions,
  getters,
};
